import 'magnific-popup'

// 変数
var prodId,keywords;

// 頭文字モーダル
function initialModalOpen(target) {
  $.magnificPopup.open({
    items: [
      {
        src: '#initialModal_'+target,
        type: 'inline',

      }
    ],
    mainClass: 'p-whiteBackModal p-initialModalWrap',
    closeOnBgClick: false,
    closeBtnInside: false,
    showCloseBtn: true,
    fixedContentPos: true,
    callbacks: {
      open: function(){
        const scrollpos = $(window).scrollTop()
        $('body').css('overflow','hidden');
        $('body').css('height','100%');
        $('html').css('height','100%');
        $('.l-container').css({
          position: 'fixed',
          height: '100%',
          overflow: 'hidden',
          width: '100%',
          top: -scrollpos,
        })
        .attr('data-top', scrollpos)
      },
      close: function(){
        $('body').css('overflow','auto');
        $('body').css('height','auto');
        $('html').css('height','auto');
        const returnpos = parseInt($('.l-container').attr('data-top'))
        $('.l-container').removeAttr('style')
        $(window).scrollTop(returnpos)
        $('.js-diQaSearchInitialBtn').parent('li').removeClass('isOpen');
      }
    }
  }, 0);
  return false;
}




$(function() {

  // モーダルOpen
  $(document).on('click touchend','.js-diQaSearchInitialBtn',  function() {
    var targetInitial = $(this).attr('data-initial');
    if($(this).parent().hasClass('isDisabled')) {
      return false;
    } else {
      $(this).parent('li').addClass('isOpen');
      initialModalOpen(targetInitial);
    }
  });

  // 製品名選択
  $(document).on('click touchend','.js-diQaSearchProdBtn',  function() {
    if($(this).hasClass('isSelected')) {
      $.magnificPopup.close();
    } else {
      $('.js-diQaSearchProdBtn').removeClass('isSelected');
      $(this).addClass('isSelected');
      var prodName = $(this).text();
      $('.js-diQaSearchProdName').addClass('isSelected').text(prodName);
      $('.js-diQaSearchInitialBtn').parent('li').removeClass('isActive');
      $('.js-diQaSearchInitialBtn').parent('li.isOpen').addClass('isActive');
      $('.js-diQaSearchInitialBtn').parent('li').removeClass('isOpen');
      $.magnificPopup.close();
      prodId = $(this).attr('data-prodid');
      if($('.js-diQaSearchKeywordInput').val() !== '' && !($('.js-diQaSearchKeywordInput').val().match(/^[ 　\r\n\t]*$/))) {
        $('.js-diQaSearchBtn').prop('disabled',false);
      }
    }
  });

  // キーワード入力
  $(document).on('input', '.js-diQaSearchKeywordInput', function(e) {
    keywords = $(this).val();
    if(prodId && keywords !== '' && !(keywords.match(/^[ 　\r\n\t]*$/))){
      $('.js-diQaSearchBtn').prop('disabled',false);
    } else {
      $('.js-diQaSearchBtn').prop('disabled',true);
    }
  });
  
  // 検索ボタン
  $(document).on('click touchend','.js-diQaSearchBtn',  function() {
    if($(this).prop('disabled',false)) {
      if(!($('.js-diQaSearchKeywordInput').val().match(/^[ 　\r\n\t]*$/))) {
        keywords = keywords.replace(/　/g,' ').replace(/ +/g,' ');
        location.href='/viatris-products/di/qa/' + prodId + '/' + keywords;
      }
    }
  });
});
